import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { Page404 } from './pages/Page404';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { LogoOnlyLayout } from './layouts/LogoOnlyLayout';
import { Page401 } from './pages/Page401';
import { Page500 } from './pages/Page500';
import { ForgotPassword } from './pages/ForgotPassword';
import { AuthLayout } from './layouts/AuthOnlyLayout';
import { SubscriptionLayout } from './layouts/SubscriptionLayout';
import { Summary } from './pages/subscription/Summary';
import { ViewBasket } from './pages/Basket/ViewBasket';
import { DashboardLayout } from './layouts/DashboardLayout';
import { AddBasket } from './pages/Basket/AddBasket';
import { PushMessage } from './pages/PushMessage';
import { ViewFarm } from './pages/Farm/ViewFarm';
import { ModifyFarm } from './pages/Farm/ModifyFarm';
import { Collection } from './pages/Collection';
import { Clients } from './pages/Clients';
import { Subscription } from './pages/subscription/Subscription';

export function Router(): React.ReactElement | null {
    return useRoutes([
        {
            path: '/',
            element: <DashboardLayout />,
            children: [
                { path: '/', element: <Navigate to="/dashboard" /> },
                { path: '/dashboard', element: <Dashboard /> },
                { path: '/view-basket/:id', element: <ViewBasket /> },
                { path: '/add-basket', element: <AddBasket /> },
                { path: '/push-message', element: <PushMessage /> },
                { path: '/view-farm', element: <ViewFarm /> },
                { path: '/modify-farm', element: <ModifyFarm /> },
                { path: '/collection/view', element: <Collection /> },
                { path: '/collection/edit', element: <Collection /> },
                { path: '/clients', element: <Clients /> },
                { path: '/modify-farm', element: <ModifyFarm /> }
            ]
        },
        { path: '*', element: <Navigate to="/404" replace /> },
        {
            path: '/auth',
            element: <AuthLayout />,
            children: [
                { path: '/auth/login', element: <Login /> },
                { path: '/auth/forgot-password', element: <ForgotPassword /> }
            ]
        },
        { path: '/register', element: <Register /> },
        {
            path: '/subscription',
            element: <SubscriptionLayout />,
            children: [
                { path: '/subscription', element: <Navigate to="/subscription/select" /> },
                { path: '/subscription/select', element: <Subscription /> },
                { path: '/subscription/success', element: <Summary /> }
            ]
        },
        {
            path: '/error',
            element: <LogoOnlyLayout />,
            children: [
                { path: '404', element: <Page404 /> },
                { path: '401', element: <Page401 /> },
                { path: '500', element: <Page500 /> }
            ]
        }
    ]);
}
